// extracted by mini-css-extract-plugin
export default {"heading1":"Home_heading1__0i9Dc","heading2":"Home_heading2__rZEd8","middle":"Home_middle__iugGX","footer":"Home_footer__+avEy","email_link":"Home_email_link__cMrJq"};